import React, { useContext, useState, useEffect } from 'react';
import { appContext } from '../context/ContextProvider';
import ConformationModal from '../components/ConformationModal'
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';
import { baseUrl } from '../utils/Constants';
import { ToastContainer, toast } from 'react-toastify';
import _ from "lodash";
import { Formik, Field } from 'formik';
import moment from 'moment';

function Phrases(props) {

    const { user, permissions } = useContext(appContext);
    const [phrases, setPhrases] = useState([]);
    const [dependencies, setDependencies] = useState({});
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [paginationData, setPaginationData] = useState({
        current_page: 0,
        first_page_url: "http://app_url/api/admin_doctors?page=1",
        from: 0,
        last_page: 0,
        last_page_url: "http://app_url/api/admin_doctors?page=2",
        next_page_url: null,
        path: "http://app_url/api/admin_doctors",
        per_page: parseInt("10"),
        prev_page_url: "http://app_url/api/admin_doctors?page=1",
        to: 0,
        total: 0
    });

    const getPagePhrases = (page) => {
        toast("Fetching phrases!");

        var requestOptions = {
            method: 'GET',
            redirect: 'follow',
        };

        fetch(`${baseUrl}/phrases?relations=language&paginated=true&limit=10&s=is_default&q=1&page=${page}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status) {
                    setPhrases(result.data.data);
                    setPaginationData({
                        current_page: result.data.current_page,
                        first_page_url: result.data.first_page_url,
                        from: result.data.from,
                        last_page: result.data.last_page,
                        last_page_url: result.data.last_page_url,
                        next_page_url: result.data.next_page_url,
                        path: result.data.path,
                        per_page: result.data.per_page,
                        prev_page_url: result.data.prev_page_url,
                        to: result.data.to,
                        total: result.data.total
                    })
                } else {
                    alert('fetch error')
                }
            })
            .catch(error => {
                console.log('error', error);
            });
    }

    const getPhrases = () => {
        toast("Fetching phrases!");

        var requestOptions = {
            method: 'GET',
            redirect: 'follow',
        };

        fetch(`${baseUrl}/phrases?relations=language&paginated=true&limit=10&s=is_default&q=1`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status) {
                    setPhrases(result.data.data);
                    setPaginationData({
                        current_page: result.data.current_page,
                        first_page_url: result.data.first_page_url,
                        from: result.data.from,
                        last_page: result.data.last_page,
                        last_page_url: result.data.last_page_url,
                        next_page_url: result.data.next_page_url,
                        path: result.data.path,
                        per_page: result.data.per_page,
                        prev_page_url: result.data.prev_page_url,
                        to: result.data.to,
                        total: result.data.total
                    })
                } else {
                    alert('fetch error')
                }
            })
            .catch(error => {
                console.log('error', error);
            });
    }

    const getLanguages = () => {
        toast("Fetching languages!");

        var requestOptions = {
            method: 'GET',
            redirect: 'follow',
        };

        fetch(`${baseUrl}/languages`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status) {
                    let temp = _.cloneDeep(dependencies);
                    temp.languages = result.data
                    setDependencies(temp);
                } else {
                    alert('fetch error')
                }
            })
            .catch(error => {
                console.log('error', error);
            });
    }

    const getDependencies = () => {
        getLanguages();
    }

    const init = () => {
        getPhrases();
        getDependencies();
    }

    useEffect(() => {
        init();
    }, []);

    const getBool = (val) => {
        return !!JSON.parse(String(val).toLowerCase());
    }

    const updateData = (values) => {

        setShowEditModal(false);

        var data = {
            "name": values.name,
            "language_id": values.language_id,
            "is_paid": getBool(values.is_paid),
        };

        var requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
            redirect: 'follow'
        };

        fetch(`${baseUrl}/phrases/${phrases[selectedIndex].id}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result) {

                    // let temp = [...phrases];
                    // temp[selectedIndex] = result;

                    // setPhrases(temp);
                    getPagePhrases(paginationData.current_page);
                    toast("Successfully Updated!");
                } else {
                    console.log('message : ', result.message);
                }
            })
            .catch(error => console.log('error', error));


    }

    const addData = (values) => {

        setShowAddModal(false);
        var data = {
            "name": values.name,
            "language_id": values.language_id,
            "is_paid": getBool(values.is_paid),
            "is_default": true,
        };

        var requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
            redirect: 'follow'
        };

        fetch(`${baseUrl}/phrases`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result) {

                    // let temp = [...shops];
                    // temp.unshift(result.items);

                    // setPhrases(temp);
                    getPhrases();
                    toast("Successfully Added!");
                } else {
                    console.log('message : ', result.message);
                }
            })
            .catch(error => console.log('error', error));


    }

    const goToPreviousPage = () => {
        paginationData.prev_page_url && getPagePhrases(paginationData.current_page - 1);
    }

    const goToNextPage = () => {
        paginationData.next_page_url && getPagePhrases(paginationData.current_page + 1);
    }

    return (
        <div>
            <ConformationModal />
            <div>
                <div className="row">
                    <div className="col-md-12">

                        <div className='headingTopStyling' >
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>

                                <h3 className="title-5 m-b-35">Phrases</h3>
                               
                            </div>
                            <div>

                                <h3>{paginationData.total} ({paginationData.from} - {paginationData.to})</h3>


                                <a className='btnstyling' href="#" onClick={goToPreviousPage} >&laquo;</a>
                                <a className='btnstyling' href="#" onClick={goToNextPage} >&raquo;</a>


                            </div>

                        </div>
                        <button type="button" class="btn btn-success" onClick={() => setShowAddModal(true)} >Add Phrase</button>

                        <div className="table-data__tool">

                        </div>
                        <div className="table-responsive table-responsive-data2">
                            <table className="table table-data2">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Language</th>
                                        <th>Paid</th>
                                        <th>Created At</th>
                                        <th>Updated At</th>
                                        {
                                            permissions.includes("phrases-edit") &&
                                            <>
                                                <th className='text-center'>Actions</th>
                                            </>
                                        }


                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        phrases.map((item, index) => {
                                            return (

                                                <tr className="tr-shadow" key={item.id} >
                                                    <td>
                                                        <span className="status--process">{item.name}</span>
                                                    </td>
                                                    <td>
                                                        <span className="status--process">{item.language && item.language != null && item.language.name}</span>
                                                    </td>
                                                    <td>
                                                        <span className="status--process">{(item.is_paid && item.is_paid != null) ? 'Paid' : 'Free'}</span>
                                                    </td>
                                                    <td>
                                                        <span className="status--process">{moment(item.created_at).format('DD MMM, YYYY')}</span>
                                                    </td>
                                                    <td>
                                                        <span className="status--process">{moment(item.updated_at).format('DD MMM, YYYY')}</span>
                                                    </td>
                                                    <td className='d-flex justify-content-center'>
                                                        <div className="table-data-feature">
                                                            {
                                                                permissions.includes("phrases-edit") &&
                                                                <>
                                                                    <button className="item" data-toggle="tooltip" data-placement="top" title="Edit" onClick={() => { setShowEditModal(true); setSelectedIndex(index) }} >
                                                                        <i className="zmdi zmdi-edit" />
                                                                    </button>
                                                                </>
                                                            }
                                                            {/* <button className="item" data-toggle="tooltip" data-placement="top" title="Delete">
                                  <i className="zmdi zmdi-delete" data-toggle="modal" data-target="#smallmodal" />
                                </button> */}

                                                        </div>
                                                    </td>
                                                </tr>


                                            )

                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <ReactModal isOpen={showEditModal}>

                    <div className="text-right">
                        <h3 className='xInmodal' onClick={() => setShowEditModal(false)}>X</h3>
                    </div>
                    <h1 className='topmodalH'>Edit Phrase</h1>

                    <br />
                    <br />
                    <Formik
                        initialValues={{ name: phrases.length > 0 && phrases[selectedIndex].name, 
                            language_id: phrases.length > 0 && phrases[selectedIndex].language && phrases[selectedIndex].language.id,
                            is_paid: phrases.length > 0 && phrases[selectedIndex].is_paid
                        }}
                        validate={values => {
                            const errors = {};
                        }}
                        onSubmit={(values, { setSubmitting }) => {
                            updateData(values);
                            // setTimeout(() => {
                            //     alert(JSON.stringify(values, null, 2));
                            //     setSubmitting(false);
                            // }, 400);
                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            setFieldValue
                            /* and other goodies */
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label className='labelName' >Name</label>
                                    <br />
                                    <input type="Text" className="form-control" placeholder="Enter Name" name='name'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.name}
                                    />
                                    <label className='labelName' >Language</label>
                                    <br />
                                    <Field as="select" name="language_id" class='form-control' >
                                    {
                                            dependencies.languages && dependencies.languages.map((item, index) => {
                                                return (
                                                    <option value={item.id}>{item.name}</option>
                                                )

                                            })
                                        }
                                    </Field>
                                    <label className='labelName' >Paid</label>
                                    <br />
                                    <span className="status--process">
                                    <label class="switch switch-3d switch-success mr-3">
                                        <input type="checkbox" class="switch-input" defaultChecked={values.is_paid} onChange={(e) => setFieldValue('is_paid', !values.is_paid)} />
                                        <span class="switch-label"></span>
                                        <span class="switch-handle"></span>
                                    </label>
                                    </span>
                                    
                                </div>
                                <button type="submit" className="btn btn-primary">
                                    Edit
                                </button>
                            </form>
                        )}
                    </Formik>

{/* 
                    <form onSubmit={updateData} >
                        <div className="form-group">
                            <label >Name</label>
                            <br />
                            <input type="Text" className="form-control" placeholder="Enter Name" value={phrases.length > 0 && phrases[selectedIndex].name} onChange={(e) => { let temp = [...phrases]; temp[selectedIndex].name = e.target.value; setPhrases(temp) }} />
                        </div>
                        <button type="submit" class="btn btn-primary">Edit</button>

                    </form> */}

                </ReactModal>

                <ReactModal isOpen={showAddModal}>

                    <div className="text-right">
                        <h3 className='xInmodal' onClick={() => setShowAddModal(false)}>X</h3>
                    </div>
                    <h1 className='topmodalH'>Add Phrase</h1>

                    <br />
                    <br />
                    <Formik
                        initialValues={{ name: '', language_id: 1, is_paid: false }}
                        validate={values => {
                            const errors = {};
                        }}
                        onSubmit={(values, { setSubmitting }) => {
                            addData(values);
                            // setTimeout(() => {
                            //     alert(JSON.stringify(values, null, 2));
                            //     setSubmitting(false);
                            // }, 400);
                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            setFieldValue
                            /* and other goodies */
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label className='labelName' >Name</label>
                                    <br />
                                    <input type="Text" className="form-control" placeholder="Enter Name" name='name'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.name}
                                    />
                                    <label className='labelName' >Language</label>
                                    <br />
                                    <Field as="select" name="language_id" class='form-control' >
                                    {
                                            dependencies.languages && dependencies.languages.map((item, index) => {
                                                return (
                                                    <option value={item.id}>{item.name}</option>
                                                )

                                            })
                                        }
                                    </Field>
                                    <label className='labelName' >Paid</label>
                                    <br />
                                    <span className="status--process">
                                    <label class="switch switch-3d switch-success mr-3">
                                        <input type="checkbox" class="switch-input" defaultChecked={values.is_paid} onChange={(e) => setFieldValue('is_paid', !values.is_paid)} />
                                        <span class="switch-label"></span>
                                        <span class="switch-handle"></span>
                                    </label>
                                    </span>
                                </div>
                                <button type="submit" className="btn btn-success btn-lg">
                                    Add
                                </button>
                            </form>
                        )}
                    </Formik>
                </ReactModal>
                <ConformationModal />
                <ToastContainer position="bottom-right" />
            </div>

        </div>
    );
}

export default Phrases;